'use client';
import i18next, {type i18n as I18n} from 'i18next';
import {useMemo, type ReactNode} from 'react';
import {I18nextProvider, initReactI18next} from 'react-i18next';
import {DEFAULT_LOCALE, type Locale} from './locale';

interface I18nProviderProps {
  locale: Locale;
  resources: Record<string, string>;
  children: ReactNode;
}

export function I18nProvider({locale, resources, children}: I18nProviderProps) {
  const instance = useMemo<I18n>(() => {
    const inst = i18next.createInstance();
    void inst.use(initReactI18next).init({
      lng: locale,
      fallbackLng: DEFAULT_LOCALE,
      resources: {[locale]: {translation: resources}},
      interpolation: {escapeValue: false},
    });
    return inst;
  }, [locale, resources]);

  return <I18nextProvider i18n={instance}>{children}</I18nextProvider>;
}
